import React, { useState } from 'react';
import SignatureModal from './Signature';
import { useFormContext } from 'react-hook-form';
import { Button } from 'primereact/button';

const SignaturePreview = ({ isFromPreview }) => {
  const { watch } = useFormContext();
  const [showSignModal, setshowSignModal] = useState(false);

  const signPreview = watch('signature-preview');
  const signature = watch('signature');

  const handleAddSignature = () => {
    setshowSignModal(true);
  };

  return (
    <div
      className=" w-100 signature-section p-3 mt-1"
      style={{ border: '0.5px dashed #bcbcbcff', pointerEvents: isFromPreview ? 'none' : 'auto' }}
    >
      <div className="signature-label" style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px', borderRadius: '4px' }}>
        <i className="pi pi-pencil"></i>
        Digital Signature Required
      </div>

      {/* Placeholder */}
      {!signature && (
        <div className="signature-placeholder" style={{ marginTop: '12px' }}>
          <p style={{ marginBottom: '5px', fontWeight: 500 }}>Please add your digital signature to complete the form.</p>
          <i style={{ fontSize: '14px' }}>Your signature will be securely stored and used to validate this document</i>
        </div>
      )}

      {/* Signature Preview */}
      {signPreview && (
        <div className="signature-preview" style={{ marginTop: '12px' }}>
          <img src={signPreview} alt="Digital Signature" height={100} />
        </div>
      )}

      {/* Buttons */}
      <div className="d-flex mt-2">
        <Button
          type="button"
          onClick={handleAddSignature}
          label={signature ? 'Re-sign' : 'Add Sign'}
          className="p-button-secondary outlined"
          icon="pi pi-plus"
        />
      </div>
      {showSignModal && <SignatureModal onHide={() => setshowSignModal(false)} />}
    </div>
  );
};

export default SignaturePreview;
